import { render, staticRenderFns } from "./SottoscrizioniSelector.vue?vue&type=template&id=2d8d3be2&"
import script from "./SottoscrizioniSelector.vue?vue&type=script&lang=js&"
export * from "./SottoscrizioniSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports